export const addItemToLibrarySaga = 'ADD_ITEM_TO_LIBRARY_SAGA';
export const setIsConfirmProfileOpen = 'SET_IS_CONFIRM_PROFILE_OPEN';
export const receiveReactorReactionRecordsSuccess = 'RECEIVE_REACTOR_REACTION_RECORDS_SUCCESS';
export const getReactorReactionsSaga = 'GET_REACTOR_REACTIONS_SAGA';
export const getMovieReactionsSaga = 'GET_MOVIE_REACTIONS_SAGA';
export const setReactorRnryUserIdToManage = 'SET_REACTOR_RNRY_USER_ID_TO_MANAGE';